import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export default function NotFoundPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate('/dashboard')
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-md text-center space-y-6">
        <h1 className="text-6xl font-bold text-primary">
          {t('errors.notFound.title')}
        </h1>
        <h2 className="text-2xl font-semibold">
          {t('errors.notFound.heading')}
        </h2>
        <p className="text-muted-foreground">{t('errors.notFound.message')}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
          <Button onClick={handleGoBack} variant="outline">
            {t('errors.notFound.goBack')}
          </Button>
          <Button onClick={handleGoHome}>
            {t('errors.notFound.goToDashboard')}
          </Button>
        </div>
      </div>
    </div>
  )
}
